"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var person_icon_svg_1 = __importDefault(require("@assets/components/directory/directory-results/person-icon.svg"));
var appMargins_1 = __importDefault(require("../../../../../app/components/AppMargins/appMargins"));
var actions_1 = __importDefault(require("../../../../../app/components/pages/RootPage/actions"));
var DirectoryFileIcon_1 = __importDefault(require("../../../../widgets/DirectoryFileIcon"));
var DirectoryUrlIcon_1 = __importDefault(require("../../../../widgets/DirectoryUrlIcon"));
var ga_1 = require("../../../../../app/util/ga");
var constants_1 = require("../../../../../../shared/constants");
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return core_1.createStyles({
        shortLinkCell: (_a = {
                display: 'inline-flex',
                width: '100%',
                paddingBottom: theme.spacing(0.5),
                borderBottom: 'none',
                margin: 0,
                marginLeft: function (props) { return props.appMargins; },
                paddingTop: theme.spacing(4),
                flexDirection: 'column'
            },
            _a[theme.breakpoints.up('md')] = {
                width: '35%',
                paddingTop: theme.spacing(6.5),
                paddingRight: function () { return '10%'; },
                marginLeft: function () { return 0; },
            },
            _a),
        longLinkText: {
            color: '#BBBBBB',
        },
        tableRow: {
            height: 'fit-content',
            border: 'none',
            padding: 0,
        },
        tableRowPaper: {
            border: 'none',
            borderRadius: 0,
            display: 'flex',
            flexWrap: 'wrap',
            marginBottom: '15px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.background.default,
                cursor: 'pointer',
            },
        },
        shortLinkText: (_b = {
                // display: 'box',
                display: '-webkit-box',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                maxWidth: '400px'
            },
            _b[theme.breakpoints.down('sm')] = {
                maxWidth: '300px',
            },
            _b),
        emailText: (_c = {
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                maxWidth: '400px'
            },
            _c[theme.breakpoints.down('sm')] = {
                maxWidth: '200px',
            },
            _c.textDecoration = 'none',
            _c['&:hover'] = {
                textDecoration: 'underline',
            },
            _c),
        domainTextInactive: (_d = {
                color: '#BBBBBB'
            },
            _d[theme.breakpoints.up('md')] = {
                maxWidth: '400px',
            },
            _d[theme.breakpoints.down('sm')] = {
                width: 'calc(100% - 32px)',
            },
            _d),
        domainTextActive: (_e = {},
            _e[theme.breakpoints.up('md')] = {
                maxWidth: '400px',
            },
            _e[theme.breakpoints.down('sm')] = {
                width: 'calc(100% - 32px)',
            },
            _e),
        urlInformationCell: {
            width: '100%',
            marginRight: 0,
        },
        contactEmailCell: (_f = {
                display: 'inline-flex',
                margin: 0,
                width: '100%',
                border: 'none',
                paddingLeft: function (props) { return props.appMargins; },
                paddingBottom: theme.spacing(4)
            },
            _f[theme.breakpoints.up('md')] = {
                paddingTop: theme.spacing(6.5),
                paddingBottom: theme.spacing(0.5),
                paddingLeft: function () { return 0; },
                width: '30%',
                flexDirection: 'column',
            },
            _f),
        IconCell: (_g = {
                display: 'inline-flex',
                verticalAlign: 'middle'
            },
            _g[theme.breakpoints.up('md')] = {
                paddingRight: theme.spacing(1.5),
                marginLeft: function (props) { return props.appMargins; },
            },
            _g),
        mailIconCell: (_h = {},
            _h[theme.breakpoints.up('md')] = {
                paddingTop: theme.spacing(5.0),
                paddingLeft: 0,
                paddingRight: theme.spacing(1),
                marginLeft: 0,
                marginRight: 0,
            },
            _h),
        personIcon: {
            marginRight: 5,
        },
        stateBox: {
            minWidth: 80,
            textTransform: 'capitalize',
            fontWeight: 600,
            // backgroundColor: theme.palette.primary.main,
            // padding: theme.spacing(1),
            // borderRadius: 30,
            textAlign: 'center',
        },
        stateActive: {
            color: constants_1.THEME_COLOR.STATE_ACTIVE,
        },
        stateInactive: {
            color: constants_1.THEME_COLOR.STATE_INACTIVE,
        },
        stateCell: (_j = {
                borderBottom: 'none'
            },
            _j[theme.breakpoints.up('md')] = {
                paddingTop: theme.spacing(6),
                minWidth: '100px',
            },
            _j[theme.breakpoints.down('sm')] = {
                display: 'inline-flex',
                width: '30%',
                minWidth: '110px',
                paddingLeft: function (props) { return props.appMargins; },
            },
            _j),
        urlText: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        spanTag: {
            fontWeight: 400,
            fontSize: '14px',
            background: theme.palette.secondary.main,
            borderRadius: '5px',
            display: 'inline',
            marginLeft: theme.spacing(0.5),
            marginRight: theme.spacing(0.5),
            paddingLeft: theme.spacing(0.5),
            paddingRight: theme.spacing(0.5),
            color: 'white',
            height: '100%',
        },
    });
});
/**
 * @component Single search result row.
 */
var DirectoryTableRow = function (_a) {
    var url = _a.url, setUrlInfo = _a.setUrlInfo, setOpen = _a.setOpen, index = _a.index;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var appMargins = appMargins_1.default();
    var classes = useStyles({ appMargins: appMargins });
    var theme = core_1.useTheme();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var dispatch = react_redux_1.useDispatch();
    var query = react_redux_1.useSelector(function (state) { return state.directory.queryForResult; });
    var onClickEvent = function (e) {
        ga_1.GAEvent('directory result', "" + query, 'open tab', parseInt("" + index, 10));
        if (!isMobileView && url.state === 'ACTIVE') {
            e.stopPropagation();
            var redirect = window.location.origin + "/" + url.shortUrl;
            window.open(redirect, '_blank', 'noopener noreferrer');
        }
        else if (isMobileView) {
            setUrlInfo(url);
            setOpen(true);
        }
    };
    var onClickEmail = function (e) {
        ga_1.GAEvent('directory result', "" + query, 'copy email', parseInt("" + index, 10));
        if (!isMobileView) {
            e.stopPropagation();
            copy_to_clipboard_1.default(url.email);
            dispatch(actions_1.default.setSuccessMessage('Email has been copied'));
        }
    };
    return (react_1.default.createElement(core_1.TableRow, { classes: { root: classes.tableRow }, onClick: function (e) { return onClickEvent(e); }, key: url.shortUrl },
        react_1.default.createElement(core_1.Paper, { elevation: 0, className: classes.tableRowPaper },
            react_1.default.createElement(core_1.TableCell, { className: classes.shortLinkCell, key: "shortUrlCell" },
                react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.shortLinkText },
                    react_1.default.createElement("div", { className: classes.IconCell }, (url === null || url === void 0 ? void 0 : url.isFile) ? (react_1.default.createElement(DirectoryFileIcon_1.default, { color: (url === null || url === void 0 ? void 0 : url.state) === 'ACTIVE'
                            ? theme.palette.primary.main
                            : '#BBBBBB' })) : (react_1.default.createElement(DirectoryUrlIcon_1.default, { color: (url === null || url === void 0 ? void 0 : url.state) === 'ACTIVE'
                            ? theme.palette.primary.main
                            : '#BBBBBB' }))),
                    react_1.default.createElement("div", { className: classes.urlText },
                        react_1.default.createElement("span", { className: url.state === 'ACTIVE'
                                ? classes.domainTextActive
                                : classes.domainTextInactive },
                            "/",
                            url.shortUrl),
                        url.tagStrings &&
                            url.tagStrings.split(constants_1.TAG_SEPARATOR).map(function (tag) { return (react_1.default.createElement("span", { className: classes.spanTag, key: tag }, tag)); }),
                        react_1.default.createElement("br", null)))),
            react_1.default.createElement(core_1.TableCell, { className: classes.contactEmailCell, key: "emailCell" }, url.email ? (react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.emailText, onClick: function (e) { return onClickEmail(e); } },
                react_1.default.createElement("div", { className: classes.IconCell },
                    react_1.default.createElement("img", { className: classes.personIcon, src: person_icon_svg_1.default, alt: "Copy email" })),
                String(url.email))) : ('')),
            react_1.default.createElement(core_1.Hidden, { smDown: true },
                react_1.default.createElement(core_1.TableCell, { className: classes.stateCell },
                    react_1.default.createElement(core_1.Box, { component: "div", className: classes.stateBox },
                        react_1.default.createElement(core_1.Typography, { variant: "caption", className: url.state === 'ACTIVE'
                                ? classes.stateActive
                                : classes.stateInactive },
                            react_1.default.createElement("b", { style: { fontWeight: 900 } }, '• '),
                            url.state === 'ACTIVE' ? t('text.active') : t('text.inactive'))))))));
};
exports.default = DirectoryTableRow;
